import Api from '../../../../redux/api';
import { omitBy as _omitBy, isEmpty as _isEmpty } from 'lodash-es';
import QueryString from 'query-string';
import { t } from 'i18next';

export default class ConnectionApi extends Api {
  getNewConnectionDetails = async queryParams => {
    const omittedPayload = _omitBy(queryParams, _isEmpty);
    const queryObj = QueryString.stringify(omittedPayload) || '';
    try {
      const apiData = await this.get(`step?${queryObj}`);
      return apiData;
    } catch (error) {
      return {
        hasError: true,
        error: error,
        customMessage: t('GRAAS_FAIL_TO_LOAD_DATA_GRAAS')
      };
    }
  };

  getReportSummary = async queryParams => {
    const omittedPayload = _omitBy(queryParams, _isEmpty);
    const queryObj = QueryString.stringify(omittedPayload) || '';
    try {
      const apiData = await this.get(`reportSummary?${queryObj}`);
      return apiData;
    } catch (error) {
      return {
        hasError: true,
        error: error,
        customMessage: t('GRAAS_FAIL_TO_LOAD_DATA_GRAAS')
      };
    }
  };

  getStoreStepDetails = async queryParams => {
    const omittedPayload = _omitBy(queryParams, _isEmpty);
    const queryObj = QueryString.stringify(omittedPayload) || '';
    try {
      const apiData = await this.get(`reportSummary/store?${queryObj}`);
      return apiData;
    } catch (error) {
      return {
        hasError: true,
        error: error,
        customMessage: t('GRAAS_FAIL_TO_LOAD_DATA_GRAAS')
      };
    }
  };

  retryFailedSteps = async payload => {
    try {
      const apiData = await this.post(`/step/retry`, payload);
      return apiData;
    } catch (error) {
      return {
        hasError: true,
        error: error,
        customMessage: t('GRAAS_FAIL_TO_LOAD_DATA_GRAAS')
      };
    }
  };
}
